module.exports = __webpack_public_path__ + "static/media/sakura_topbcd3e5870635968ed63bd3fc7da0e729.webp";